// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"92c5274a","908":"c8f77b47"}[chunkId] + ".chunk.js";
};